module.exports = __webpack_public_path__ + "img/item4-3.ed47da74.png";